// src/WelcomeScreen.jsx
import React, { useState } from 'react'; 
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useUser } from './context/UserContext';
import { AlertCircle, LoaderCircle } from 'lucide-react';
import ReportIssueModal from './components/ReportIssueModal'; 
// import { GoogleLogin } from '@react-oauth/google';   // <-- DESATIVADO

export default function WelcomeScreen() {
  const navigate = useNavigate();
  const { login } = useUser();
  const [isReportModalVisible, setIsReportModalVisible] = useState(false); 
  
  // Login por ops_id/senha
  const [opsId, setOpsId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // -----------------------------
  // LOGIN POR OPS_ID + SENHA
  // -----------------------------
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await axios.post('/api/login/password', {
        ops_id: opsId,
        password,
      });

      if (response.data && response.data.user) {
        sessionStorage.setItem('app_token', response.data.token); 
        login(response.data.user);
        navigate('/home');
      } else {
        setError('Credenciais inválidas.');
      }
    } catch (error) {
      console.error("Erro no login:", error.response?.data?.detail || error.message);
      setError(error.response?.data?.detail || 'Falha no login. Verifique seus dados.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <div style={styles.logoContainer}>
          <img
            src={process.env.PUBLIC_URL + '/ic_target.png'}
            alt="App Logo"
            style={styles.logo}
          />
        </div>

        <div style={styles.whitePanel}>
          <h2 style={styles.title}>Entrar</h2>

          {/* LOGIN GOOGLE (DESATIVADO) */}
          {/*
          <div style={{ marginBottom: 40 }}>
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              useOneTap
              size="large"
              width="300"
            />
          </div>
          */}

          {/* LOGIN OPSID / SENHA */}
          <form onSubmit={handleLogin} style={styles.form}>
            <input
              type="number"
              placeholder="OpsId"
              value={opsId}
              onChange={(e) => setOpsId(e.target.value)}
              required
              style={styles.input}
            />
            <input
              type="password"
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={styles.input}
            />

            {error && <p style={styles.errorText}>{error}</p>}

            <button type="submit" style={styles.submitButton} disabled={isLoading}>
              {isLoading ? <LoaderCircle className="animate-spin" /> : 'Entrar'}
            </button>
          </form>

          <button
            style={styles.linkButton}
            type="button"
            onClick={() => navigate('/reset-password')}
          >
            Esqueci Minha Senha
          </button>

          <div style={styles.firstAccessText}>
            Este é o seu primeiro acesso?
          </div>

          <button
            type="button"
            onClick={() => navigate('/register')}
            style={styles.linkButton}
          >
            Cadastre-se
          </button>
        </div>
      </div>

      {/* Botão flutuante */}
      <button
        onClick={() => setIsReportModalVisible(true)}
        className="fixed bottom-6 right-6 bg-[#EE4D2D] text-white p-3 rounded-full shadow-lg hover:bg-[#D03F2A] transition-all duration-300 z-40 opacity-80 hover:opacity-100"
        title="Relatar um Problema"
      >
        <AlertCircle size={24} />
      </button>

      <ReportIssueModal
        isVisible={isReportModalVisible}
        onClose={() => setIsReportModalVisible(false)}
        screenName="welcome"
      />
    </div>
  );
}

// -----------------------------------------
// ESTILOS
// -----------------------------------------
const styles = {
  wrapper: { 
    position: 'fixed', 
    top: 0, 
    left: 0, 
    width: '100vw', 
    height: '100vh', 
    overflow: 'hidden', 
    background: 'linear-gradient(180deg, #FF5722 0%, #EE4D2D 100%)' 
  },
  container: { 
    display: 'flex', 
    flexDirection: 'column', 
    height: '100%', 
    width: '100%' 
  },
  logoContainer: { 
    flex: 5, 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center' 
  },
  logo: { 
    width: '100vw', 
    maxWidth: 350, 
    height: 'auto', 
    objectFit: 'contain' 
  },
  whitePanel: { 
    flex: 5, 
    backgroundColor: 'white', 
    borderTopLeftRadius: 24, 
    borderTopRightRadius: 24, 
    padding: '24px', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center',
    boxShadow: '0 -4px 8px rgba(0,0,0,0.1)', 
    margin: '0 10px' 
  },
  title: { 
    fontSize: 22, 
    fontWeight: 'bold', 
    color: '#333', 
    textAlign: 'center', 
    marginBottom: 20 
  },
  form: { 
    display: 'flex', 
    flexDirection: 'column', 
    gap: 16, 
    width: '100%', 
    maxWidth: 320 
  },
  input: { 
    padding: '12px 16px', 
    fontSize: 16, 
    border: '1px solid #ddd', 
    borderRadius: 8, 
    outline: 'none' 
  },
  submitButton: { 
    padding: '12px 16px', 
    fontSize: 16, 
    fontWeight: 'bold', 
    color: 'white', 
    backgroundColor: '#EE4D2D', 
    border: 'none', 
    borderRadius: 8, 
    cursor: 'pointer', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    transition: 'background-color 0.2s' ,
    marginTop: 16
  },
  errorText: { 
    color: 'red', 
    textAlign: 'center', 
    fontSize: 14, 
    marginTop: -8 
  },
  linkButton: { 
    backgroundColor: 'transparent', 
    color: '#2196F3', 
    border: 'none', 
    textDecoration: 'underline', 
    cursor: 'pointer', 
    fontSize: 14, 
    marginTop: 12,
    marginBottom: 32
  },
  firstAccessText: { 
    fontSize: 14, 
    color: '#555', 
    marginTop: 20 
  }
};
